module.exports = __webpack_public_path__ + "static/media/austin.23998a44.jpeg";